import { useSelector } from "react-redux";
import { useAnonymousToken } from "./useAnonymousToken";
import selectors from "../../../selectors";

export function useAnonymousTokenNetworkHeaders() {
  const token = useAnonymousToken((state) => state.token);
  const site = useSelector(selectors.site).site;

  if (!token) {
    return {
      "Content-Type": "application/json",
      "X-GOGOVAPPS-SITE": site,
    };
  }

  return {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
    "X-GOGOVAPPS-SITE": site,
  };
}
